import React from 'react'
import * as Fields from 'support/fields'
import { observer } from 'mobx-react'
import { useEnvValue } from '@morningtrain/react-helpers'

function AdministrativeToggleCheckbox () {
  const [isAdministrative, setIsAdministrative] = useEnvValue('toggle.administrative', 0)

  const updateIsAdministrative = (e) => {
    // If value is 'administrative' set 1, else 0, to match logic in backend
    setIsAdministrative(e === '2' ? 1 : 0)
  }

  return (
    <div className='administrative toggle-checkbox pl-8'>
      <Fields.TabsField
        name='toggle.toggle_type'
        enum='toggle_type'
        only={['1', '2']}
        onChange={e => updateIsAdministrative(e)}
        defaultValue={1}
      />
    </div>
  )
}

export default observer(AdministrativeToggleCheckbox)
